import { useContext } from 'react';
import { ManageTableContext } from '../../ManageTableProvider';
import { UseManageTableReturnType } from '../useManageTable';

type UseManageTableContextType = UseManageTableReturnType;

export const useManageTableContext = (): UseManageTableContextType => {
  const context = useContext(ManageTableContext);

  if (!context) {
    throw new Error(
      'useManageTableContext must be used within a ManageTableProvider'
    );
  }

  return context as UseManageTableContextType;
};
